var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var SINDARIN_API_URL = 'https://api.prod.centralus.az.sindarin.tech';
var PersonaService = (function () {
    function PersonaService(apiKey) {
        this.apiKey = apiKey;
    }
    PersonaService.prototype.getConversationData = function (conversationId) {
        return __awaiter(this, void 0, void 0, function () {
            var res, data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, fetch("".concat(SINDARIN_API_URL, "/api/conversations/").concat(conversationId, "?apikey=").concat(this.apiKey))];
                    case 1:
                        res = _a.sent();
                        return [4, res.json()];
                    case 2:
                        data = _a.sent();
                        return [2, data];
                    case 3:
                        error_1 = _a.sent();
                        throw error_1;
                    case 4: return [2];
                }
            });
        });
    };
    PersonaService.prototype.fetchPersonas = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, data, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, fetch("".concat(SINDARIN_API_URL, "/api/personas?apikey=").concat(this.apiKey))];
                    case 1:
                        res = _a.sent();
                        return [4, res.json()];
                    case 2:
                        data = _a.sent();
                        return [2, data];
                    case 3:
                        error_2 = _a.sent();
                        throw error_2;
                    case 4: return [2];
                }
            });
        });
    };
    PersonaService.prototype.fetchLLMs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, data, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, fetch("".concat(SINDARIN_API_URL, "/api/llms?apikey=").concat(this.apiKey))];
                    case 1:
                        res = _a.sent();
                        return [4, res.json()];
                    case 2:
                        data = _a.sent();
                        return [2, data];
                    case 3:
                        error_3 = _a.sent();
                        throw error_3;
                    case 4: return [2];
                }
            });
        });
    };
    PersonaService.prototype.fetchTranscripts = function (userIds, personaIds, start, end, page) {
        return __awaiter(this, void 0, void 0, function () {
            var res, data, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, fetch("".concat(SINDARIN_API_URL, "/api/transcripts?apikey=").concat(this.apiKey, "&start=").concat(start !== null && start !== void 0 ? start : '', "&end=").concat(end !== null && end !== void 0 ? end : '', "&personaIds=").concat(personaIds !== null && personaIds !== void 0 ? personaIds : '', "&userIds=").concat(userIds !== null && userIds !== void 0 ? userIds : '', "&page=").concat(page !== null && page !== void 0 ? page : ''))];
                    case 1:
                        res = _a.sent();
                        return [4, res.json()];
                    case 2:
                        data = _a.sent();
                        return [2, data];
                    case 3:
                        error_4 = _a.sent();
                        throw error_4;
                    case 4: return [2];
                }
            });
        });
    };
    PersonaService.prototype.fetchTeam = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, data, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, fetch("".concat(SINDARIN_API_URL, "/api/team?apikey=").concat(this.apiKey))];
                    case 1:
                        res = _a.sent();
                        return [4, res.json()];
                    case 2:
                        data = _a.sent();
                        return [2, data];
                    case 3:
                        error_5 = _a.sent();
                        throw error_5;
                    case 4: return [2];
                }
            });
        });
    };
    PersonaService.prototype.changeLLM = function (personaId, llm) {
        return __awaiter(this, void 0, void 0, function () {
            var res, data, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, fetch("".concat(SINDARIN_API_URL, "/api/personas/").concat(personaId, "/llm?apikey=").concat(this.apiKey), {
                                method: 'PUT',
                                body: JSON.stringify({ llm: llm }),
                                headers: {
                                    Accept: 'application/json, text/plain, */*',
                                    'Content-Type': 'application/json',
                                },
                            })];
                    case 1:
                        res = _a.sent();
                        return [4, res.text()];
                    case 2:
                        data = _a.sent();
                        return [2, {
                                status: res.status,
                                data: data,
                            }];
                    case 3:
                        error_6 = _a.sent();
                        throw error_6;
                    case 4: return [2];
                }
            });
        });
    };
    PersonaService.prototype.fetchVoices = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, data, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, fetch("".concat(SINDARIN_API_URL, "/api/voices?apikey=").concat(this.apiKey))];
                    case 1:
                        res = _a.sent();
                        return [4, res.json()];
                    case 2:
                        data = _a.sent();
                        return [2, data];
                    case 3:
                        error_7 = _a.sent();
                        throw error_7;
                    case 4: return [2];
                }
            });
        });
    };
    PersonaService.prototype.changeVoice = function (personaId, voiceId) {
        return __awaiter(this, void 0, void 0, function () {
            var res, data, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, fetch("".concat(SINDARIN_API_URL, "/api/personas/").concat(personaId, "/voice?apikey=").concat(this.apiKey), {
                                method: 'PUT',
                                body: JSON.stringify({ voiceId: voiceId }),
                                headers: {
                                    Accept: 'application/json, text/plain, */*',
                                    'Content-Type': 'application/json',
                                },
                            })];
                    case 1:
                        res = _a.sent();
                        return [4, res.text()];
                    case 2:
                        data = _a.sent();
                        return [2, {
                                status: res.status,
                                data: data,
                            }];
                    case 3:
                        error_8 = _a.sent();
                        throw error_8;
                    case 4: return [2];
                }
            });
        });
    };
    PersonaService.prototype.changeInitialMessage = function (personaId, initialMessage) {
        return __awaiter(this, void 0, void 0, function () {
            var res, data, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, fetch("".concat(SINDARIN_API_URL, "/api/personas/").concat(personaId, "/initialMessage?apikey=").concat(this.apiKey), {
                                method: 'PUT',
                                body: JSON.stringify({ initialMessage: initialMessage }),
                                headers: {
                                    Accept: 'application/json, text/plain, */*',
                                    'Content-Type': 'application/json',
                                },
                            })];
                    case 1:
                        res = _a.sent();
                        return [4, res.text()];
                    case 2:
                        data = _a.sent();
                        return [2, {
                                status: res.status,
                                data: data,
                            }];
                    case 3:
                        error_9 = _a.sent();
                        throw error_9;
                    case 4: return [2];
                }
            });
        });
    };
    PersonaService.prototype.changeRateLimitMessage = function (personaId, rateLimitMessage) {
        return __awaiter(this, void 0, void 0, function () {
            var res, data, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, fetch("".concat(SINDARIN_API_URL, "/api/personas/").concat(personaId, "/rateLimitMessage?apikey=").concat(this.apiKey), {
                                method: 'PUT',
                                body: JSON.stringify({ rateLimitMessage: rateLimitMessage }),
                                headers: {
                                    Accept: 'application/json, text/plain, */*',
                                    'Content-Type': 'application/json',
                                },
                            })];
                    case 1:
                        res = _a.sent();
                        return [4, res.text()];
                    case 2:
                        data = _a.sent();
                        return [2, {
                                status: res.status,
                                data: data,
                            }];
                    case 3:
                        error_10 = _a.sent();
                        throw error_10;
                    case 4: return [2];
                }
            });
        });
    };
    PersonaService.prototype.toggleRateLimit = function (personaId, enabled) {
        return __awaiter(this, void 0, void 0, function () {
            var res, data, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, fetch("".concat(SINDARIN_API_URL, "/api/personas/").concat(personaId, "/toggleRateLimit?apikey=").concat(this.apiKey), {
                                method: 'PUT',
                                body: JSON.stringify({ enabled: enabled }),
                                headers: {
                                    Accept: 'application/json, text/plain, */*',
                                    'Content-Type': 'application/json',
                                },
                            })];
                    case 1:
                        res = _a.sent();
                        return [4, res.text()];
                    case 2:
                        data = _a.sent();
                        return [2, {
                                status: res.status,
                                data: data,
                            }];
                    case 3:
                        error_11 = _a.sent();
                        throw error_11;
                    case 4: return [2];
                }
            });
        });
    };
    PersonaService.prototype.changePrompt = function (personaId, prompt) {
        return __awaiter(this, void 0, void 0, function () {
            var res, data, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, fetch("".concat(SINDARIN_API_URL, "/api/personas/").concat(personaId, "/prompt?apikey=").concat(this.apiKey), {
                                method: 'PUT',
                                body: JSON.stringify({ prompt: prompt }),
                                headers: {
                                    Accept: 'application/json, text/plain, */*',
                                    'Content-Type': 'application/json',
                                },
                            })];
                    case 1:
                        res = _a.sent();
                        return [4, res.text()];
                    case 2:
                        data = _a.sent();
                        return [2, {
                                status: res.status,
                                data: data,
                            }];
                    case 3:
                        error_12 = _a.sent();
                        throw error_12;
                    case 4: return [2];
                }
            });
        });
    };
    PersonaService.prototype.changeSchema = function (personaId, schema) {
        return __awaiter(this, void 0, void 0, function () {
            var res, data, error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, fetch("".concat(SINDARIN_API_URL, "/api/personas/").concat(personaId, "/schema?apikey=").concat(this.apiKey), {
                                method: 'PUT',
                                body: schema,
                                headers: {
                                    Accept: 'application/json, text/plain, */*',
                                    'Content-Type': 'application/json',
                                },
                            })];
                    case 1:
                        res = _a.sent();
                        return [4, res.text()];
                    case 2:
                        data = _a.sent();
                        return [2, {
                                status: res.status,
                                data: data,
                            }];
                    case 3:
                        error_13 = _a.sent();
                        throw error_13;
                    case 4: return [2];
                }
            });
        });
    };
    PersonaService.prototype.changeScenarios = function (personaId, scenarios) {
        return __awaiter(this, void 0, void 0, function () {
            var res, data, error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, fetch("".concat(SINDARIN_API_URL, "/api/personas/").concat(personaId, "/scenarios?apikey=").concat(this.apiKey), {
                                method: 'PUT',
                                body: JSON.stringify({ scenarios: scenarios }),
                                headers: {
                                    Accept: 'application/json, text/plain, */*',
                                    'Content-Type': 'application/json',
                                },
                            })];
                    case 1:
                        res = _a.sent();
                        return [4, res.text()];
                    case 2:
                        data = _a.sent();
                        return [2, {
                                status: res.status,
                                data: data,
                            }];
                    case 3:
                        error_14 = _a.sent();
                        throw error_14;
                    case 4: return [2];
                }
            });
        });
    };
    PersonaService.prototype.changePersonaName = function (personaId, name) {
        return __awaiter(this, void 0, void 0, function () {
            var res, data, error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, fetch("".concat(SINDARIN_API_URL, "/api/personas/").concat(personaId, "/name?apikey=").concat(this.apiKey), {
                                method: 'PUT',
                                body: JSON.stringify({ name: name }),
                                headers: {
                                    Accept: 'application/json, text/plain, */*',
                                    'Content-Type': 'application/json',
                                },
                            })];
                    case 1:
                        res = _a.sent();
                        return [4, res.text()];
                    case 2:
                        data = _a.sent();
                        return [2, {
                                status: res.status,
                                data: data,
                            }];
                    case 3:
                        error_15 = _a.sent();
                        throw error_15;
                    case 4: return [2];
                }
            });
        });
    };
    PersonaService.prototype.makeCall = function (personaId, phoneNumber, details, record) {
        return __awaiter(this, void 0, void 0, function () {
            var res, data, error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, fetch("".concat(SINDARIN_API_URL, "/api/personas/").concat(personaId, "/makecall?apikey=").concat(this.apiKey), {
                                method: 'PUT',
                                body: JSON.stringify({ phoneNumber: phoneNumber, details: details, record: record }),
                                headers: {
                                    Accept: 'application/json, text/plain, */*',
                                    'Content-Type': 'application/json',
                                },
                            })];
                    case 1:
                        res = _a.sent();
                        return [4, res.text()];
                    case 2:
                        data = _a.sent();
                        return [2, {
                                status: res.status,
                                data: data,
                            }];
                    case 3:
                        error_16 = _a.sent();
                        throw error_16;
                    case 4: return [2];
                }
            });
        });
    };
    PersonaService.prototype.playVoiceSample = function (voiceId) {
        return __awaiter(this, void 0, void 0, function () {
            var res, blob, url, audio_1, error_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4, fetch("".concat(SINDARIN_API_URL, "/api/voices/").concat(voiceId, "/sample?apikey=").concat(this.apiKey), {
                                headers: {
                                    'Content-Type': 'audio/mpeg',
                                },
                            })];
                    case 1:
                        res = _a.sent();
                        return [4, res.blob()];
                    case 2:
                        blob = _a.sent();
                        if (blob.type === 'application/octet-stream') {
                            blob = new Blob([blob], { type: 'audio/mp3' });
                        }
                        url = window.URL.createObjectURL(blob);
                        audio_1 = new Audio();
                        audio_1.src = url;
                        audio_1.volume = 1.0;
                        audio_1.muted = false;
                        audio_1.load();
                        audio_1.addEventListener('error', function (e) {
                            console.error('Error playing audio:', e);
                        });
                        audio_1.addEventListener('canplaythrough', function () {
                            audio_1.play().catch(function (error) {
                                console.error('Error playing audio', error);
                            });
                        });
                        return [4, audio_1.play()];
                    case 3:
                        _a.sent();
                        return [2, {
                                status: res.status,
                            }];
                    case 4:
                        error_17 = _a.sent();
                        throw error_17;
                    case 5: return [2];
                }
            });
        });
    };
    return PersonaService;
}());
export default PersonaService;
